import React, {Component, Fragment} from 'react';
import style from '../css/racingCard.css';
import {connect} from 'react-redux';
import RacersListSingleBets from './racersListSingleBets';
import RacersListComplexBets from './racersListComplexBets';
import ActiveBetsSummary from '../../../components/activeBetsSummary';
import ToggleButton from '../../../components/toggleButton';
import {getText} from '../../../../../helpers/localization';
import {FORECAST, PLACE, SHOW, TO_WIN} from '../constants/identifiers';
import {SORT_BY_NUMBER} from '../constants/sortingTypes';
import {HARD_SUSPENDED, MARBLES, NMB, PRE, RES, SOFT_SUSPENDED, VID} from '../../../../../constants/identifiers';
import {getAllWrappedBets, isEnabledMarket, showBetSummary} from '../../../helpers/betHelpers';
import {getDefaultEachWayString} from '../../../../../helpers/eachWayBetHelpers';

//actions
import {selectRacingBetType, toggleRaceCardSortFieldSelection} from '../actions/raceCardActions';
import {isMarbleEvent} from "../helpers/racersHelper";
import OverlayContainer from './../../../containers/overlayContainer';


const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        betHistoryBets: state.vpp.betHistoryBets,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        selectedRaceCardSortField: state.vpp.selectedRaceCardSortField,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        systemLanguage: state.vpp.systemLanguage,
        channelEventBets: state.vpp.channelEventBets,
        disabledMarkets: state.vpp.disabledMarkets
    };
};

class RacingCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            betHistoryBets: storeData.vpp.betHistoryBets,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            selectedRaceCardSortField: storeData.vpp.selectedRaceCardSortField,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            systemLanguage: storeData.vpp.systemLanguage,
            channelEventBets: storeData.vpp.channelEventBets,
            disabledMarkets: storeData.vpp.disabledMarkets
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                games: storeData.vpp.games,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                betHistoryBets: storeData.vpp.betHistoryBets,
                selectedRacingBetType: storeData.vpp.selectedRacingBetType,
                selectedRaceCardSortField: storeData.vpp.selectedRaceCardSortField,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                systemLanguage: storeData.vpp.systemLanguage,
                channelEventBets: storeData.vpp.channelEventBets,
                disabledMarkets: storeData.vpp.disabledMarkets
            });
        }
    }

    render() {
        let bettingCardType = this.state.selectedRacingBetType === TO_WIN
            ? <RacersListSingleBets id='racersListSingleBets' store={this.props.store}/>
            : <RacersListComplexBets id='racersListComplexBets' store={this.props.store}/>;

        let store = this.props.store;
        let storeData = store.getState();
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];

        let betSummaryOverlay;
        let eventBets;
        if (selectedEvent) {
            eventBets = getAllWrappedBets(this.state, selectedEvent.channel).filter(
                (pBet) => pBet.Bets[0].EventId === selectedEvent.eventId.toString() && pBet.Bets[0].Channel === selectedEvent.channel
            );
        }
        let overlayType;
        if (selectedEvent && this.props.overlay === undefined) {
            for (let i = 0; i < storeData.vpp.noMoreBetsEventList.length; i++) {
                if (storeData.vpp.noMoreBetsEventList[i].eventId === selectedEvent.eventId && storeData.vpp.noMoreBetsEventList[i].gameChannel === selectedGame.channel) {
                    if (selectedGame.controllerState === PRE || selectedGame.controllerState === NMB) {
                        overlayType = 'NMB';
                    } else if (selectedGame.controllerState === VID || selectedGame.controllerState === RES) {
                        if (eventBets && eventBets.length > 0) {
                            betSummaryOverlay = (<ActiveBetsSummary store={this.props.store} activeBets={eventBets}/>);
                        } else {
                            overlayType = 'LIVE'
                        }
                    }
                    break;
                }
            }
        }

        if (selectedEvent && this.props.overlay === undefined) {
            if (storeData.vpp.games[storeData.vpp.selectedGameIndex].state.toString() === HARD_SUSPENDED ||
                (storeData.vpp.games[storeData.vpp.selectedGameIndex].state.toString() === SOFT_SUSPENDED && betSummaryOverlay === undefined)) {
                overlayType = 'GAME_DISABLED'
            }
        }

        let eachwayText;
        if (this.state.selectedRacingBetType === TO_WIN && this.state.selectedEventIndex !== undefined && storeData.vpp.events !== undefined
            && storeData.vpp.events[this.state.selectedEventIndex] !== undefined) {
            if (storeData.vpp.events[this.state.selectedEventIndex].markets.find(m => m.code.toString() === SHOW.code)) {
                const eachWayRatio = storeData.vpp.events[this.state.selectedEventIndex].eachWayRatio;
                eachwayText = getText('EACH_WAY_ODDS_SHOW', this.props.store, [eachWayRatio === undefined ? getDefaultEachWayString() : eachWayRatio]);
            } else if (storeData.vpp.events[this.state.selectedEventIndex].markets.find(m => m.code.toString() === PLACE.code)) {
                const eachWayRatio = storeData.vpp.events[this.state.selectedEventIndex].eachWayRatio;
                eachwayText = getText('EACH_WAY_ODDS_PLACE', this.props.store, [eachWayRatio === undefined ? getDefaultEachWayString() : eachWayRatio]);
            }
        }

        let buttons = (
            <div className={style.buttonsContainer}>
                <div
                    id='toWinButton'
                    className={`${style.betTypeButton} ${this.state.selectedRacingBetType === TO_WIN
                        ? style.selected
                        : ''}`}
                    onClick={() => this.props.store.dispatch(selectRacingBetType(TO_WIN))}>{getText('RACE_CARD', this.props.store)}
                    <span
                        className={` ${this.state.selectedRacingBetType === TO_WIN
                            ? style.triangleDown : style.triangleLeft}`}/>
                </div>

                <div
                    id='forecastTricastButton'
                    className={`${style.betTypeButton} ${this.state.selectedRacingBetType !== TO_WIN
                        ? style.selected
                        : ''}`}
                    onClick={() => this.props.store.dispatch(selectRacingBetType(FORECAST))}>{selectedEvent.eventType === MARBLES ? getText('FINISHING_ORDER', this.props.store) : getText('FORECAST_TRICAST', this.props.store)}
                    <span
                        className={` ${this.state.selectedRacingBetType !== TO_WIN
                            ? style.triangleDown : style.triangleLeft}`}/>
                </div>
            </div>
        );

        let channel = this.state.games[storeData.vpp.selectedGameIndex].channel;
        let toWinHeader;
        let placeHeader;
        let showHeader;
        if (isEnabledMarket(this.state, this.props.disabledMarkets, channel, TO_WIN.name) && selectedEvent.racers[0].oddsFirst != undefined) {
            toWinHeader = (<div className={style.winPlaceShow}>
                {getText('WIN', this.props.store)}
            </div>);
        }
        if (isEnabledMarket(this.state, this.props.disabledMarkets, channel, PLACE.name) && selectedEvent.racers[0].oddsPlace != undefined) {
            placeHeader = (<div className={style.winPlaceShow}>
                {getText('PLACE', this.props.store)}
            </div>);
        }
        if (isEnabledMarket(this.state, this.props.disabledMarkets, channel, SHOW.name) && selectedEvent.racers[0].oddsShow != undefined) {
            showHeader = (<div className={style.winPlaceShow}>
                {getText('SHOW', this.props.store)}
            </div>);
        }

        let sortingContainer = this.state.selectedRacingBetType === TO_WIN ? (
            <div className={style.sortingButtonContainer}>
                <div className={style.sortingContainer}>
                    {!isMarbleEvent(selectedEvent.eventType) ? (<Fragment>
                        <ToggleButton
                            htmlId='sortRacersToggleButton'
                            style={style.toggleNumber}
                            isChecked={this.state.selectedRaceCardSortField === SORT_BY_NUMBER}
                            callback={() => this.props.store.dispatch(toggleRaceCardSortFieldSelection())}
                            leftText={getText('ODDS', this.props.store)}
                            rightText={getText('NUMBER', this.props.store)}/></Fragment>) : ('')}

                </div>
                <div className={style.winPlaceShowContainer}>
                    {toWinHeader}
                    {placeHeader}
                    {showHeader}
                </div>
            </div>
        ) : '';


        let gameCards = (
            <div className={style.gameCardsContainer}>
                {sortingContainer}
                {bettingCardType}
            </div>
        );

        if (showBetSummary(this.props.showLoadingOverlay, selectedGame, selectedEvent, storeData.vpp.noMoreBetsEventList, this.state)) {
            buttons = '';
            gameCards = '';
        }
        let overlay = <OverlayContainer store={this.props.store} showLoadingOverlay={this.props.showLoadingOverlay}/>

        return (
            <Fragment>
                <div id={'racing_card'} className={style.mainContainer}>
                    {overlay}
                    {buttons}
                    {gameCards}
                </div>
            </Fragment>
        );
    }

}

export default connect(mapStateToProps)(RacingCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/containers/racingCard.js